/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employee_selfservice_MyAvailabilityRuleResponse = {
    end_time: string;
    id: string;
    kind: employee_selfservice_MyAvailabilityRuleResponse.kind;
    start_time: string;
    weekday: number;
};
export namespace employee_selfservice_MyAvailabilityRuleResponse {
    export enum kind {
        AVAILABLE = 'available',
        UNAVAILABLE = 'unavailable',
    }
}

